import { render } from "./Version.vue?vue&type=template&id=4ecaab0e&scoped=true"
import script from "./Version.vue?vue&type=script&lang=js"
export * from "./Version.vue?vue&type=script&lang=js"

import "./Version.vue?vue&type=style&index=0&id=4ecaab0e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ecaab0e"]])

export default __exports__